import * as React from 'react';
import { translate } from 'react-i18next';
import { InnerSetupPrivacyPolicyComponent, IProps } from './setup-privacy-policy';
import { AppContext } from '@src/context/store';
import { getKBLinks } from '@src/context/selectors/ui-settings';

export const SetupPrivacyPolicyComponent = translate()(({ t, className }: Pick<IProps, 'className' | 't'>) => {
  const store = React.useContext(AppContext);
  const kbLinks = getKBLinks(store);

  return (
    <InnerSetupPrivacyPolicyComponent
      t={t}
      className={className}
      addKBLink={kbLinks.AddPrivacyPolicyLearnHow}
      learnKBLink={kbLinks.CreatingAPrivacyPolicy}
    />
  );
});
